import {h, Component} from 'preact'
import {connect} from 'react-redux'

import reduce from '../reducers'
import store from '../store'
import * as actions from '../actions'
import util from '../util'

export default @connect(reduce, actions)
class PrintAdvisor extends Component {
    constructor() {
        super()
        
        this.state = {}
        
        this.nextStep = () => {
        	const printAdvisor = {
		      ...store.getState().printAdvisor
		    }
			printAdvisor.step++;
        	store.dispatch(actions.updatePrintAdvisor(printAdvisor));
        }
        
        this.disablePrintAdvisor = () => {
        	util.disableFullScreenPreview();
        }
        
        this.userAgreementHandler = (event) => {
        	const printAdvisor = {
		      ...store.getState().printAdvisor
		    }
        	printAdvisor.allowPrint = !printAdvisor.allowPrint;
		    store.dispatch(actions.updatePrintAdvisor(printAdvisor));
        }
        
        this.addToCart = () => {
					store.dispatch(actions.setIsAppLoading(true, "Preparing your design for print..."));

        	const printAdvisor = store.getState().printAdvisor;
        	if (printAdvisor.allowPrint) {
        		util.disableFullScreenPreview();
				window.ignoreBeforeUnloadWarning = true;
        		window.location=store.getState().printAdvisor.addToCartURL;
        	}
        }
    }

    render (props, state) {
        
    	const printAdvisor = store.getState().printAdvisor;
    	const step = printAdvisor.step;
    	
    	
    	util.showPrintAdvisorHints(props.designSize);
    	
    	let stepContent = (
    						<div>
    							<div className="triangle-left"></div>
    	    					<h2>Check Edges</h2>
    							<p>Be sure your images and background extend to each edge to avoid white edges.</p>
    						</div>
    					);
    	if(step === 2){
    		stepContent = (
    						<div>
    							<div className="triangle-left"></div>
    							<h2>Check red zone</h2>
    							<p>Keep text out of red zone as safety margin.</p>
    						</div>
    					);
        }
    	if(step === 3){
    		stepContent = (
    			<div>
    				<h2>Check for the following</h2>
    				<p>
    					<ul>
    						<li>Blank pages</li>
    						<li>Overlapping content</li>
    						<li>Misspellings</li>
        				</ul>
    				</p>
    			</div>
    		);
        }

    	if (step === 4) {
    		stepContent = (
    				<div>
    					<h2>Ready to print</h2><div className="checkbox"><span><input checked={printAdvisor.allowPrint} type="checkbox" onChange={this.userAgreementHandler}/></span><span>I have reviewed my order and confirm it is free of errors and ready to print.</span></div></div>);
        }
    	
    	let nextStepButton = null;
    	let fixButton = null;
    	if(step < 4){
    		fixButton = (<a className="btn" onClick={this.disablePrintAdvisor}>Fix It</a>);
    		nextStepButton = (<a className="btn primary" onClick={this.nextStep}>Next</a>);
    	}else{
    		const addToCartClasses = ['btn','secondary'];
    		let addToCartText = 'Add to Print Cart';
    		if(!printAdvisor.allowPrint){
    			addToCartClasses.push('disabled');
    		}
    		if(printAdvisor.isProductInCart){
    			addToCartText = 'Update in Print Cart';
        	}
    		nextStepButton = (<a className={addToCartClasses.join(' ')} onClick={this.addToCart}>{addToCartText}</a>);
        }
    	
    	return (
            <div className="pa-advisor" id="pa-advisor">
            	<div className="advisor-step">
            		{ stepContent }
            	</div>
            	<div className="pa-buttons">
            		{ fixButton } { nextStepButton }
            	</div>
            </div>
        )
    }
}
